import { integer, nullable, object, string } from 'superstruct';
export const ViewArcGroupDto = object({
  id: integer(),
  odooId: integer(),
  name: string(),
  displayName: string(),
  comment: nullable(string()),
  category: nullable(object({
    id: integer(),
    odooId: integer(),
    name: string()
  }))
});